var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showBtn)?_c('div',{staticClass:"apple-pay"},[_c('button',{on:{"click":function($event){return _vm.onApplePaymentButtonClicked()}}},[_c('img',{attrs:{"src":require("../../../assets/images/svg/apple-pay-ico.svg")}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }